module.exports = __webpack_public_path__ + "img/anevil.7305260e.jpeg";